{
  "name": "12-Subharmonic (Elsie Hamilton) E-A-D 13-limit",
  "description": "12-tone 13-Limit Rational Intonation (JI) scale. Derived from the subharmonic partial row, it is limited to partials u8-u15 under F-comma-up, as well as subharmonics of E (A, D, F, B).",
  "scale": [
    "12/11",
    "8/7",
    "6/5",
    "5/4",
    "4/3",
    "45/32",
    "3/2",
    "8/5",
    "12/7",
    "24/13",
    "15/8",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "12-HamiltonModes",
  "built_in_group": "12 Note Scales",
  "key_labels": "note_names",
  "fundamental_color": "#ffdbe8",
  "note_names": ["B", "C", "C", "D", "*nD", "E", "*nE", "F", "G", "G", "A", "*nA"],
  "note_colors": [
    "#ff9191",
    "#b6e8a1",
    "#eecbc9",
    "#beb58f",
    "#ffffff",
    "#c7c1a1",
    "#ffffff",
    "#e9e1b4",
    "#beb58f",
    "#eecbc9",
    "#ddcce6",
    "#ffffff"
  ],
  "equivSteps": 12,
  "fundamental": 440,
  "reference_degree": 11,
  "center_degree": 6,
  "rSteps": 2,
  "drSteps": 1,
  "hexSize": 42,
  "rotation": -16.102113751
}
